import { useContext, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { ContentBody, ContentHeader } from 'components/shared/content'
import { ActionTableCell, CheckboxTableRow, ExTable, TableBody, TableCell, TableHead, TableWrapper, useMultipleCheckForm } from 'components/shared/widget'
import { useConfirmQcLedgerApi, useDownloadCsvQcLedgersApi, useFetchQcLedgersApi } from 'api/qc_ledger'
import { QcLedger, QcLedgerSearchForm } from 'entities/qc_ledger'
import { Pagination } from 'components/shared/pagination'
import { useEffectSkipFirst, useForm, useQuery } from 'utils/hooks'
import { SearchConditionView } from 'components/shared/search_drawer'
import { GlobalStateContext } from 'contexts/global_state_context'
import { qcLedgerColumnInfoList, QcLedgerTableData } from './qc_ledger_table'
import { TableHeads, useDisplaySetting } from 'components/shared/display_setting'
import { useState } from 'react'
import { EditQcLedgerForm, NewQcLedgerForm } from './qc_ledger_form'
import { Flex } from 'components/shared/flex'
import { Button } from 'react-bootstrap'

type Props = {
    history: H.History
}

const QcLedgersPage = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const params = useQuery<QcLedgerSearchForm>()
    const searchForm = useForm<QcLedgerSearchForm>({ ordering: '-qc_ledger_create_date', ...params })
    const api = useFetchQcLedgersApi(searchForm)
    const downloadCsvApi = useDownloadCsvQcLedgersApi(searchForm)
    const multipleCheckForm = useMultipleCheckForm<QcLedger>()
    const qcLedgerDisplaySetting = useDisplaySetting(qcLedgerColumnInfoList(searchForm), 'QcLedger')
    const [selectedQcLedger, setSelectedQcLedger] = useState<QcLedger>({})
    const [showEdit, setShowEdit] = useState<boolean>(false)
    const confirmApi = useConfirmQcLedgerApi()

    useEffect(() => {
        api.execute()
    }, [])

    const handleClickRemoveFilter = (key: keyof QcLedgerSearchForm): void => {
        searchForm.update((f) => {
            delete f[key]
        })
    }

    const handleClickEdit = (qcLedger: QcLedger) => {
        setSelectedQcLedger(qcLedger)
        setShowEdit(true)
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(downloadCsvApi.loading)
    }, [downloadCsvApi.loading])

    useEffectSkipFirst(() => {
        globalState.setLoading(confirmApi.loading)
        if (confirmApi.isSuccess()) {
            api.execute()
        }
    }, [confirmApi.loading])

    return (
        <>
            <EditQcLedgerForm
                qcLedger={selectedQcLedger}
                show={showEdit}
                onClose={() => setShowEdit(false)}
                onComplete={() => {
                    api.execute()
                    setShowEdit(false)
                }}
            />

            <ContentHeader
                headerTitle="統計学的精度管理台帳"
                left={
                    <>
                        {/* <CopyTableButton /> */}

                        <NewQcLedgerForm
                            onComplete={() => {
                                api.execute()
                            }}
                        />
                        <SearchConditionView searchForm={searchForm} onClickRemoveButton={handleClickRemoveFilter} />
                    </>
                }
                right={<>{/* <DisplaySettingModal displaySettings={displaySettings} /> */}</>}
            />
            <Flex style={{ marginTop: 5 }} alignItems="center" justifyContent="space-between">
                <div></div>
                <Flex alignItems="center">
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                    <div style={{ minWidth: 140, textAlign: 'right' }}>総件数： {api.response.count.toLocaleString()}件</div>
                </Flex>
            </Flex>
            <ContentBody>
                <TableWrapper contentHeaderCount={2}>
                    <ExTable className="sticky-table">
                        <TableHead>
                            <CheckboxTableRow head allCheck allItems={api.response.results} multipleCheckForm={multipleCheckForm} showEdit>
                                <ActionTableCell th width={60} />
                                <TableHeads displaySetting={qcLedgerDisplaySetting} />
                                <TableCell th width={100} />
                            </CheckboxTableRow>
                        </TableHead>
                        <TableBody loading={api.loading} columnLength={qcLedgerDisplaySetting.getColumnLength() + 3}>
                            {api.response.results.map((qcLedger: QcLedger) => {
                                return (
                                    <CheckboxTableRow
                                        key={`qcLedger-${qcLedger.id}`}
                                        item={qcLedger}
                                        multipleCheckForm={multipleCheckForm}
                                        onClickEdit={() => handleClickEdit(qcLedger)}
                                    >
                                        <ActionTableCell
                                            action="edit"
                                            onClick={() => {
                                                setSelectedQcLedger(qcLedger)
                                                setShowEdit(true)
                                            }}
                                        />
                                        <QcLedgerTableData qcLedger={qcLedger} displaySetting={qcLedgerDisplaySetting} />
                                        <TableCell align="center">
                                            <Button
                                                variant="secondary"
                                                onClick={() => {
                                                    props.history.push('/ledgers/qc/' + qcLedger.id!)
                                                }}
                                            >
                                                印刷
                                            </Button>
                                        </TableCell>
                                    </CheckboxTableRow>
                                )
                            })}
                        </TableBody>
                    </ExTable>
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                </TableWrapper>
            </ContentBody>
        </>
    )
}

export default withRouter(QcLedgersPage)
